var he_IL = {
  "Add Upsell.com to your ": "הוסף את Upsell.com ל",
  "All time": "כל הזמן",
  "and select": "ובחר",
  "button": "כפתור",
  "Cart drawer page": "דף מגירת העגלה",
  "Cart page": "דף העגלה",
  "Check status": "בדוק סטטוס",
  "Checkout page": "דף הצ'ק-אאוט",
  "Click": "לחץ על",
  "Click on": "לחץ על",
  "Click the": "לחץ על ה",
  "Custom slot": "מקום מותאם אישית",
  "Custom slots": "מקומות מותאמים אישית",
  "Custom Slots": "מקומות מותאמים אישית",
  "contact support.": "צור קשר עם התמיכה.",
  "from the right sidebar": "מסרגל הצד הימני",
  "Go to your Cart drawer page": "עבור לדף מגירת העגלה שלך",
  "Go to your Cart page": "עבור לדף העגלה שלך",
  "Go to your Checkout page": "עבור לדף הצ'ק-אאוט שלך",
  "Go to your Order status page": "עבור לדף סטטוס ההזמנה שלך",
  "Go to your Post purchase page": "עבור לדף שלאחר הרכישה שלך",
  "Go to your Product page": "עבור לדף המוצר שלך",
  "Go to your Thank you page": "עבור לדף התודה שלך",
  "items": "פריטים",
  "in the left sidebar": "בסרגל הצד השמאלי",
  "Last 12 months": "12 החודשים האחרונים",
  "Last 30 days": "30 הימים האחרונים",
  "Last 365 days": "365 הימים האחרונים",
  "Last 7 days": "7 הימים האחרונים",
  "Last 90 days": "90 הימים האחרונים",
  "Last month": "חודש שעבר",
  "Last year": "שנה שעברה",
  "Make sure": "וודא ש",
  "Need assistance? Contact our support team for help.": "צריכים עזרה? צרו קשר עם צוות התמיכה שלנו.",
  "Order status page": "דף סטטוס הזמנה",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "האפליקציה שלנו עוברת כרגע שדרוג קסום כדי לשפר את החוויה שלכם.",
  "Post purchase page": "דף שלאחר רכישה",
  "Product page": "דף המוצר",
  "Save": "שמור",
  "Scroll to the bottom and select": "גלול לתחתית ובחר",
  "Select": "בחר",
  "Success. Please continue.": "הצלחה. אנא המשך.",
  "Thank you page": "דף תודה",
  "The Upsell.com team.": "צוות Upsell.com.",
  "The Upsell.com widget is not placed on ": "הווידג'ט של Upsell.com לא מוצב ב",
  ". Please follow the steps above or ": ". אנא עקוב אחר השלבים למעלה או ",
  "Today": "היום",
  "toggle is on": "המתג דולק",
  "Total": "סה״כ",
  "under": "תחת",
  "We apologize for any inconvenience caused,": "אנו מתנצלים על אי הנוחות,",
  "We apologize for any inconvenience caused.": "אנו מתנצלים על אי הנוחות.",
  "We'll be done in a few minutes!": "נסיים תוך מספר דקות!",
  "We're improving our services!": "אנחנו משפרים את השירותים שלנו!",
  "Widget already added": "הווידג'ט כבר נוסף",
  "Yesterday": "אתמול",
  "You placed the widget on the ": "הצבת את הווידג'ט ב",
  ", but you didn't save it in Shopify editor. Please go back to ": ", אבל לא שמרת אותו בעורך של Shopify. אנא חזור ל",
  " and save the changes.": " ושמור את השינויים."
};

export { he_IL as default };
//# sourceMappingURL=he_IL.json.js.map
